import createSentry from "@services/create-sentry"
import Vue from "vue"
import PublicOfferView from "./views/PublicOffer/PublicOfferView"
import store from "./state/index"
import axios from "~axios"
import "~taiwind"
import notifier from "@components/Notifications/notifier"
import { t } from "@helpers"
import modalLangs from "@public-modal/shared/langs"

axios.defaults.baseURL = "/api/v1"

Object.defineProperty(String.prototype, "capitalize", {
    value: function () {
        return this.charAt(0).toUpperCase() + this.slice(1)
    },
    enumerable: false,
    configurable: true
})

let dataset = document.querySelector("#public-offer").dataset

let { offer, product, auth, order, message, isAuthTypeBefore, isProductOnSale, payment } = dataset

const { token, app_current_locale } = window

if (!token) {
    auth = false
} else {
    axios.defaults.headers.common = {
        Authorization: `Bearer ${token}`,
        "X-Language": app_current_locale
    }
}

if (typeof auth === "string") {
    auth = Boolean(auth)
}
if (typeof isProductOnSale === "string") {
    isProductOnSale = isProductOnSale === "true"
}

if (auth === null) {
    auth = false
}

const viewed = {
    props: {},
    el: "",
    component: null
}

viewed.props = {
    product: product ? JSON.parse(product) : null,
    offer: offer ? JSON.parse(offer) : null,
    defOrder: order ? JSON.parse(order) : null,
    defPayment: payment ? JSON.parse(payment) : null,
    message,
    auth,
    authBefore: !!parseInt(isAuthTypeBefore),
    isProductOnSale
}
viewed.component = PublicOfferView
viewed.el = "#public-offer"

let currentuser = null

Promise.all([
    store.dispatch("user/fetchUser"),
    store.dispatch("user/fetchCabinets"),
    store.dispatch("user/fetchIsProductionMode"),
    store.dispatch("langs/fetchLangs")
])
    .then(([user]) => {
        currentuser = user
    })
    .catch(() => {
        auth = false
    })
    .finally(() => {
        Vue.mixin({
            methods: {
                t(key, parameters) {
                    let langs = { ...modalLangs[app_current_locale] }
                    if (this.langs) {
                        langs = { ...langs, ...this.langs }
                    }
                    return t(key, langs, parameters)
                },
                $t(key) {
                    return modalLangs[app_current_locale] ? modalLangs[app_current_locale][key] : modalLangs["en"][key]
                }
            },
            computed: {
                langs() {
                    if (this.$store && this.$store.getters["langs/getLangs"]) {
                        return { ...this.$store.getters["langs/getLangs"], ...modalLangs[app_current_locale] }
                    } else {
                        return modalLangs[app_current_locale]
                    }
                },
                $screenWidth() {
                    return this.$vssWidth
                },
                $screenHeight() {
                    return this.$vssHeight
                }
            }
        })
        Vue.prototype.$notify = notifier.exec

        new Vue({
            el: viewed.el,
            store,
            render: h =>
                h(viewed.component, {
                    props: viewed.props
                })
        })

        createSentry(Vue, null, currentuser)
    })
